import { useIdentifyForAnalytics } from "@mightybot/core";

const AnalyticsIdentityBridge = () => {
	useIdentifyForAnalytics();
	return null;
};

export default AnalyticsIdentityBridge;
